import React, { useEffect, useState, useMemo } from "react";
import { useDispatch, useSelector } from "react-redux";
import cookie from "react-cookies";
import { useNavigate } from "react-router-dom";
import { Icons } from "../constants/icon-library";
import { clearUser } from "../features/user/userSlice";
import { ROLE } from "../constants/constants";
import { upsertSetting } from "../features/settings/settingsSlice";

const Header = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const { user } = useSelector((state) => state.user);
  const { balance } = useSelector((state) => state.transactions);
  const [theme, setTheme] = useState(
    localStorage.getItem("phoenixTheme") || "light",
  );

  useEffect(() => {
    const currentTheme = localStorage.getItem("phoenixTheme") || "light";
    document.body.classList.toggle("dark", currentTheme === "dark");

    const toggle = document.getElementById("themeControlToggle");
    if (toggle) {
      toggle.checked = currentTheme === "dark";

      toggle.addEventListener("change", () => {
        const newTheme = toggle.checked ? "dark" : "light";
        localStorage.setItem("phoenixTheme", newTheme);

        document.body.classList.toggle("dark", newTheme === "dark");

        setTheme(newTheme);
      });
    }
  }, []);

  const handleLogout = () => {
    cookie.remove("token", { path: "/" });
    dispatch(clearUser());
    dispatch(upsertSetting());
    navigate("/sign-in", { replace: true });
  };

  const handleProfile = () => {
    navigate("/profile");
  };

  const displayName = useMemo(() => {
    if (user?.name?.trim()) return user.name;
    return "User";
  }, [user?.name]);

  const role = user ? user?.role : null;

  return (
    <nav
      className="navbar navbar-top fixed-top navbar-expand"
      id="navbarDefault"
    >
      <div className="collapse navbar-collapse justify-content-between">
        <div className="navbar-logo">
          <button
            className="btn navbar-toggler navbar-toggler-humburger-icon hover-bg-transparent"
            type="button"
            data-bs-toggle="collapse"
            data-bs-target="#navbarVerticalCollapse"
            aria-controls="navbarVerticalCollapse"
            aria-expanded="false"
            aria-label="Toggle Navigation"
          >
            <span className="navbar-toggle-icon">
              <span className="toggle-line"></span>
            </span>
          </button>
          <a className="navbar-brand me-1 me-sm-3" href="/">
            <div className="d-flex align-items-center">
              <img
                src={
                  theme === "dark"
                    ? "/assets/img/icons/logo.png"
                    : "/assets/img/icons/logo-dark.png"
                }
                alt="gennie"
                width={100}
              />
            </div>
          </a>
        </div>

        <ul className="navbar-nav navbar-nav-icons flex-row align-items-center">
          <li className="nav-item">
            <div className="theme-control-toggle px-2">
              <input
                className="form-check-input ms-0 theme-control-toggle-input"
                type="checkbox"
                data-theme-control="phoenixTheme"
                value="dark"
                id="themeControlToggle"
              />

              <label
                className="mb-0 theme-control-toggle-label theme-control-toggle-light"
                htmlFor="themeControlToggle"
                style={{ height: "32px", width: "32px" }}
              >
                <i className={`wb ${Icons("moon")} mt-1 align-middle`} />
              </label>

              <label
                className="mb-0 theme-control-toggle-label theme-control-toggle-dark"
                htmlFor="themeControlToggle"
                style={{ height: "32px", width: "32px" }}
              >
                <i className={`wb ${Icons("sun")} mt-1 align-middle`} />
              </label>
            </div>
          </li>
          {role === ROLE.USER && (
            <li
              className="nav-item"
              onClick={() => navigate("/billing")}
              style={{ cursor: "pointer" }}
            >
              <div className="ms-3 mt-2">
                <h4 className="mb-0">{balance?.netBalance}</h4>
                <p className="text-body-secondary fs-9 mb-0">
                  Available Credits
                </p>
              </div>
            </li>
          )}
          <li className="nav-item dropdown">
            <a
              className="nav-link lh-1 pe-0 text-body d-flex align-items-center"
              id="navbarDropdownUser"
              href="#!"
              role="button"
              data-bs-toggle="dropdown"
              data-bs-auto-close="true"
              aria-haspopup="true"
              aria-expanded="false"
            >
              <div className="avatar avatar-l me-2">
                <img
                  className="rounded-circle"
                  src="/assets/img/team/image.png"
                  alt=""
                />
              </div>
              <div className="d-flex flex-column justify-content-center">
                <span className="fs-8 mt-1">{displayName}</span>
              </div>
            </a>

            <style>
              {`
                .navbar .dropdown-menu.navbar-dropdown-caret::after {
                  display: none !important;
                }
              `}
            </style>

            <div
              className="dropdown-menu dropdown-menu-start navbar-dropdown-caret py-0 dropdown-profile shadow border"
              aria-labelledby="navbarDropdownUser"
              style={{ position: "absolute" }}
            >
              <div className="card position-relative border-0">
                <div className="card-body p-0">
                  <div className="text-center pt-4 pb-3">
                    <div className="avatar avatar-xl">
                      <img
                        className="rounded-circle"
                        src="/assets/img/team/image.png"
                        alt=""
                      />
                    </div>
                    <h6 className="mt-2 text-body-emphasis">{displayName}</h6>
                  </div>
                </div>

                <div className="card-footer p-0 border-top border-translucent">
                  <div className="px-3 d-flex flex-column gap-2">
                    <button
                      className="btn btn-phoenix-primary d-flex flex-center w-100"
                      onClick={() => handleProfile(role)}
                    >
                      <i
                        className={`wb ${Icons(
                          "user",
                        )} fs-8 me-2 mt-1 align-middle`}
                      ></i>
                      Profile
                    </button>

                    <button
                      className="btn btn-phoenix-secondary d-flex flex-center w-100"
                      onClick={handleLogout}
                    >
                      <i
                        className={`wb ${Icons(
                          "logoutUser",
                        )} fs-8 me-2 mt-1 align-middle`}
                      ></i>
                      Sign out
                    </button>
                  </div>
                  <div className="my-2 text-center fw-bold fs-10 text-body-quaternary"></div>
                </div>
              </div>
            </div>
          </li>
        </ul>
      </div>
    </nav>
  );
};

export default Header;
